<!--
@Author: MIYONGLE
@Desc: 解决方案-通用方案
@Date: 2021-07-28 13时
-->
<template>
  <div class="page-main">
  <!-- 顶部 -->
  <mMenusNav><span>{{ titleName }}</span></mMenusNav>
  <!-- 背景 -->
  <div class="banner-box">
    <div class="title">场景化<br>灵活用工服务平台</div>
    <div class="txt">根据行业及企业用工场景，提供高效的产品解决方案，精准打击行业痛点</div>
    <div class="btn" @click="opearMth">立即咨询</div>
  </div>

  <!-- 灵活用工模式痛点 -->
  <div class="solve-problem">
    <div class="solve-problem-title">灵活用工模式痛点</div>
    <div class="solve-problem-switch">
      <span class="tab" :class="activeType == 'one' && 'active'" @click="clickTab('one')">企业</span>
      <span class="tab" :class="activeType == 'two' && 'active'" @click="clickTab('two')">新个体</span>
      <p :class="activeType == 'one' && 'slider'"></p>
      <p :class="activeType == 'two' && 'slider1'"></p>
      <!-- 场景主题 -->
      <div class="tab-content">
        <div class="tab-box" v-for="(item, index) in productList" :key="index">
          <img :src="item.imgUrl" alt="">
          <p class="title">{{item.title}}</p>
          <p class="text">{{item.text}}</p>
        </div>
      </div>
    </div>    
  </div>
    <!-- 即时配送行业解决方案 -->
  <div class="min-width-pc">
    <div class="title-txt">即时配送行业解决方案</div>
    <div class="product-text">
      新经济合作模式
    </div>
    <div class="line"></div>
    <p class="text">根据行业及客户真实场景制定专属高效的产品解决方案</p>
    <div class="solution-img">
      <img src="../../../static/mobile/msolution/img_solution_12.png" alt="">
    </div>

    <div class="product-text">
      「自然人」众包模式
    </div>
    <div class="line"></div>
    <p class="text2">根据行业及客户真实场景制定专属高效的产品解决方案</p>
    <div class="solution-img">
      <img src="../../../static/mobile/msolution/img_solution_13.png" alt="">
    </div>
  </div>
  <!-- 慧用工方案优势 -->
  <div class="advantage">
    <div class="title-txt">慧用工方案优势</div>
    <div v-for="item in advantageArry" :key="item.titleName" class="case-item">
        <img :src="item.src" alt="">
        <div class="text-box">
          <p class="title">{{item.titleName}}</p>
          <p class="txt">
            {{item.text}}
          </p>
        </div>
    </div>
  </div>

    <!-- form弹窗 -->
    <mFrom :source='source'></mFrom>
  </div>
</template>

<script type="text/javascript">
import mMenusNav from "../../components/mMenusNav";
import mFrom from "../../components/mFrom";
import {TONGYONG_TAGEARRY} from "../../service/businessConsts";
export default {
  name: "app",
  data() {
    return {
      source: '',
      titleName: "通用方案",
      productList:[
        {imgUrl:'../../../static/mobile/msolution/Solution_icon_qiye_1.png', title:'税务风险高', text:'企业给灵活用工人员结算，无合规发票入账'},
        {imgUrl:'../../../static/mobile/msolution/Solution_icon_qiye_2.png', title:'用工风险高', text:'用工隶属关系不明确，社保补缴、劳动仲裁风险高'},
        {imgUrl:'../../../static/mobile/msolution/Solution_icon_qiye_3.png', title:'用工管理难', text:'跨地区信息采集、薪酬管理、签约管理等难度大'},
        {imgUrl:'../../../static/mobile/msolution/Solution_icon_qiye_4.png', title:'结算时效差', text:'个人对结算时效要求高，但资金体量大，效率低'},
      ],
      advantageArry:TONGYONG_TAGEARRY,
      activeType: 'one',
    }
  },
  components: {
    mMenusNav: mMenusNav,
    mFrom: mFrom,
  },
  created() {
    // source来源：：
    let hash = window.location.hash;
    this.source = hash.indexOf('source') > 0 ? hash.substring(hash.indexOf('source')) + '&pageFrom=mjjfa_tyfa' : '&pageFrom=mjjfa_tyfa';
  },
  methods: {
    opearMth(){
      eventBus.$emit("operaDiaLog", true);
    },
    clickTab(type){
      this.activeType = type;
      if(type == 'one'){
        this.productList = [
          {imgUrl:'../../../static/mobile/msolution/Solution_icon_qiye_1.png', title:'个人税负高', text:'企业给灵活用工人员结算，无合规发票入账'},
          {imgUrl:'../../../static/mobile/msolution/Solution_icon_qiye_2.png', title:'年底汇算清缴', text:'用工隶属关系不明确，社保补缴、劳动仲裁风险高'},
          {imgUrl:'../../../static/mobile/msolution/Solution_icon_qiye_3.png', title:'个人扣税困难', text:'跨地区信息采集、薪酬管理、签约管理等难度大'},
          {imgUrl:'../../../static/mobile/msolution/Solution_icon_qiye_4.png', title:'开票难度大', text:'个人对结算时效要求高，但资金体量大，效率低'}
        ]

      } else if(type == 'two'){
        this.productList = [
          {imgUrl:'../../../static/mobile/msolution/Solution_icon_geren_1.png', title:'个人税负高', text:'个人按劳务报酬所得20-40%缴纳个税，税负重'},
          {imgUrl:'../../../static/mobile/msolution/Solution_icon_geren_2.png', title:'年底汇算清缴', text:'个人按劳务所得，年底汇算清缴，可能涉及补税'},
          {imgUrl:'../../../static/mobile/msolution/Solution_icon_geren_3.png', title:'个人扣税困难', text:'个人纳税意识不高，认为到手金额应该为约定金额'},
          {imgUrl:'../../../static/mobile/msolution/Solution_icon_geren_4.png', title:'开票难度大', text:'企业要求个人提供发票，但个人取得发票难度大'}
        ]
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.banner-box{
  width: 100% ;
  height: 1080px;
  overflow: hidden;
  background-image: url(../../../static/mobile/msolution/banner_solution_1.png);
  background-size:100% ;
  background-color: #111010;
  .title{
    margin: 354px auto 29px;
    // width: 622px;
    height: 152px;
    font-size: 60px;
    text-align: center;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #FFFFFF;
    line-height: 76px;
  }
  .txt{
    margin: 0 auto;
    // width: 403px;
    padding: 0px 173.5px;
    height: 80px;
    font-size: 22px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 40px;
  }
  .btn{
    margin:0 auto;
    margin-top: 66px;
    width: 288px;
    height: 80px;
    background: #1985FF;
    border-radius: 40px;
    font-size: 30px;
    text-align: center;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 80px;
  }
}

.solve-problem{
  margin:0 auto;
  // width: 750px;
  width: 100%;
  height: 1100px;
  overflow: hidden;
  background: #FBFDFF;
  .solve-problem-title{
    margin: 0 auto;
    margin-top: 70px;
    // width: 400px;
    height: 56px;
    font-size: 40px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #100F0F;
    line-height: 56px;
  }
  .solve-problem-switch{
    margin: 0 auto;
    width: 690px;
    height: 106px;
    background-color: #fff;
    border-bottom: 1px solid #CFCFCF;
    .tab{
      margin-top: 53px;
      display: inline-block;
      margin-right: 50px;
      margin-left: 50px;
      font-size: 32px;
      font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi;
      font-weight: 500;
      color: #171E2E;
    }
    .active{
      color:rgb(25, 133, 255);
    }
    .slider{
      margin-top: 7px;
      margin-left: 150px;
      width: 180px;
      height: 4px;
      background: #1985FF;
      box-shadow: 0px 20px 60px 0px rgba(0, 0, 0, 0.1);
      border-radius: 25px;
    }
    .slider1{
      margin-top: 7px;
      margin-left: 330px;
      width: 180px;
      height: 4px;
      background: #1985FF;
      box-shadow: 0px 20px 60px 0px rgba(0, 0, 0, 0.1);
      border-radius: 25px;
    }
    .tab-content{
      width: 690px;
      height: 750px;
      display: flex;
      flex-flow: wrap;
      justify-content: space-around;
      .tab-box{
        width: 335px;
        height: 340px;
        margin-top: 32px;
        background: #FFFFFF;
        box-shadow: 0px 20px 60px -20px rgba(0, 0, 0, 0.1);
        img{
          margin: 55px auto 32px;
          width: 100px;
          height: 100px;
        }
        .title{
          // width: 140px;
          text-align: center;
          height: 40px;
          font-size: 28px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #403F3F;
          line-height: 40px;
        }
        .text{
          // width: 266px;
          padding: 0px 34.5px;
          height: 60px;
          margin: 0 auto;
          margin-top: 15px;
          font-size: 22px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #403F3F;
          line-height: 30px;
        }
      }
    }
  }
}

.min-width-pc{
  margin: 0 auto;
  // width: 750px;
  width: 100%;
  overflow: hidden;
  background-color: #FBFDFF;
  .title-txt{
    margin:0 auto;
    // width: 400px;
    height: 56px;
    font-size: 40px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #100F0F;
    line-height: 56px;
  }
  .product-text{
    margin:0 auto;
    margin-top: 53px;
    // width: 405px;
    // padding: 0px 127.5px;
    height: 40px;
    text-align: center;
    font-size: 28px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #403F3F;
    line-height: 40px;
  }
  .line{
    margin: 0 auto;
    margin-top: 10px;
    width: 24px;
    height: 4px;
    background: #1985FF;
    border-radius: 4px;
  }
  .text{
    margin: 0 auto;
    margin-top: 10px;
    // width: 305px;
    // padding: 0px 177.5px;
    height: 60px;
    font-size: 22px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #403F3F;
    line-height: 30px;
  }
  .text2{
    margin: 0 auto;
    margin-top: 10px;
    // width: 345px;
    height: 40px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #403F3F;
    line-height: 40px;
  }
  .solution-img{
    margin: 0 auto;
    height: 342px;
    margin-top: 32px;
    margin-bottom: 72px;
    img{
      width: 100%;
      height: 100%;
    }
  }
}

.advantage{
  margin: 0 auto;
  // width: 750px;
  width: 100%;
  height: 1130px;
  overflow: hidden;
  background: #FBFDFF;
  .title-txt{
    margin:31px auto 53px;
    // width: 280px;
    height: 56px;
    font-size: 40px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #100F0F;
    line-height: 56px;
  }
  .case-item{
    width: 690px;
    height: 208px;
    display: inline-flex;
    padding:30px 20px 0 30px;
    background: #FFFFFF;
    box-shadow: 0px 20px 60px -20px rgba(0, 0, 0, 0.1);
    margin-bottom: 20px;
    box-sizing: border-box;
    &:hover{
      position: relative;
      top:-5px;
      background-color: rgba(255, 255, 255, 1);
      box-shadow: 0px 20px 20px 0px rgba(16, 15, 15, 0.09);
    }
    img{
      width: 70px;
      height: 70px;
      // vertical-align: top;
      margin-right:38px;
    }
    .text-box{
      line-height: 32px;
      color: #403F3F;
      font-weight: 400;
      font-size: 22px;
      text-align: left;
      .title{
        color: #403F3F;
        font-size: 28px;
        text-align: center;
        font-family: AlibabaPuHuiTi-Medium;
        font-weight: 500;
        text-align: left;
        line-height: 38px;
        margin-bottom: 20px;
      }
    }
  }
}


</style>


// WEBPACK FOOTER //
// src/views/mobile/mSolution_normal.vue